import styles from './index.less';
import { FC } from 'react';
import { Mask } from 'antd-mobile';
import developUrl from '@/assets/global/develop.png';
import closeIconUrl from '@/assets/global/close_icon.png';

interface IMaskDialogProps {
  visible: boolean;
  close: (value: boolean) => void;
}

const MaskDialog: FC<IMaskDialogProps> = (props) => {
  const { visible, close } = props;

  return (
    <>
      <Mask visible={visible} opacity={'thick'}>
        <div className={styles['container']}>
          <div className={styles.mask}>
            <img src={developUrl} alt={'develop'} />
            <p className={styles.text}>
              此功能程序猿还在
              <span className={styles['text-red']}> “爆肝” </span>
              开发中{' '}
            </p>
            <p className={styles['text-blue']}>请耐心等待哈 ~</p>
            <div className={styles['close-btn']}>
              <img
                src={closeIconUrl}
                alt={'close'}
                onClick={() => close(false)}
              />
            </div>
          </div>
        </div>
      </Mask>
    </>
  );
};

export default MaskDialog;
